/*
 * @Description:客户及商机刷新销售合同列表
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-08-16 09:47:12
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { contractService } from '@/api/';
import { defineStore } from 'pinia';
import { Message } from '@arco-design/web-vue';
export const useContractStore = defineStore('getContractList', {
  state: () => ({
    contractList: [],
    contractParams: {},
    isRefresh: false
  }),
  actions: {
    //获取合同数据列表
    getContractLists(params) {
      this.contractList = [];
      this.contractParams = params;
      return new Promise((resolve, reject) => {
        contractService
          .getContractList(params)
          .then((json) => {
            if (json.error) {
              Message.error(json.error?.msg || '操作失败');
            }
            this.contractList = json.result;
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || '合同数据获取失败');
            reject(err);
          });
      });
    },
    //更新是否刷新的标识
    updateRefresh(flag) {
      this.isRefresh = flag;
    }
  }
});

export default useContractStore;
